import React, { useState, useRef } from 'react';

interface Props {
  label: string;
  delay?: number;
  onDelete: () => void;
}

const DeleteButton: React.FC<Props> = ({ label, onDelete, delay }) => {
  const [progress, setProgress] = useState(0);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const duration = delay ?? 5000;

  const startHold = () => {
    const startTime = Date.now();
    intervalRef.current = setInterval(() => {
      const elapsed = Date.now() - startTime;
      const newProgress = Math.min((elapsed / duration) * 100, 100);
      setProgress(newProgress);
      if (newProgress >= 100) {
        clearInterval(intervalRef.current!);
        onDelete();
        setProgress(0);
      }
    }, 16); // ~60fps
  };

  const stopHold = () => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    setProgress(0);
  };

  return (
    <button
      type="button"
      onMouseDown={startHold}
      onMouseUp={stopHold}
      onMouseLeave={stopHold}
      onTouchStart={startHold}
      onTouchEnd={stopHold}
      className="btn btn-danger fw-bold position-relative overflow-hidden rounded-3 px-4 py-2"
      style={{ border: 'none' }}
    >
      {/* Barre de progression */}
      <div
        className="position-absolute top-0 start-0 h-100 bg-white bg-opacity-25"
        style={{ 
          width: `${progress}%`, 
          transition: 'width 0.1s linear',
          zIndex: 1
        }}
      />
      <span className="position-relative" style={{ zIndex: 10 }}>
        {label}
      </span>
    </button>
  );
};

export default DeleteButton;
